import b_max from '../../../../assets/media/b-max-logo1.svg';
import b_white from '../../../../assets/media/b-white-logo1.svg';
import ozon4 from '../../../../assets/media/ozon4.svg';
import ozon5 from '../../../../assets/media/ozon5.svg';
import ozon6 from '../../../../assets/media/ozon6.svg';
import ozon7 from '../../../../assets/media/ozon7.svg';
import ururu from '../../../../assets/media/ururu-logo.svg';
import wb1 from '../../../../assets/media/wb1.svg';
import wb2 from '../../../../assets/media/wb2.svg';
import wb3 from '../../../../assets/media/wb3.svg';
import wb4 from '../../../../assets/media/wb4.svg';
import wb5 from '../../../../assets/media/wb5.svg';
import wb6 from '../../../../assets/media/wb6.svg';
import wb7 from '../../../../assets/media/wb7.svg';
import yandex1 from '../../../../assets/media/yandex1.svg';
import yandex2 from '../../../../assets/media/yandex2.svg';
import yandex4 from '../../../../assets/media/yandex4.svg';
import yandex5 from '../../../../assets/media/yandex5.svg';
import yandex6 from '../../../../assets/media/yandex6.svg';
import yandex7 from '../../../../assets/media/yandex7.svg';
import yandex8 from '../../../../assets/media/yandex8.svg';
import yandex3 from '../../../../assets/media/yandexEp.svg';

import sber from '../../../../assets/media/sber1.svg';
import sber2 from '../../../../assets/media/sber2.svg';
import Icon from '../../../Basic/Elements/Icon';

const market_default = {
  ozon: [],
  ozon2: [],
  ozon3: [],
  ozon4: [],
  ozon5: [],
  ozon6: [],
  ozon7: [],
  wb: [],
  wb2: [],
  wb3: [],
  wb4: [],
  wb5: [],
  wb6: [],
  wb7: [],
  yandex: [],
  yandex2: [],
  yandex3: [],
  yandex4: [],
  yandex5: [],
  yandex6: [],
  yandex7: [],
  yandex8: [],
  kaspi: [],
  aliexpress: [],
  sber: [],
  sber2: [],
};

const MarketsPairs = ({ market = market_default, width = '36px', ...props }) => {
  const getIcon = (shop, icon) => {
    if (!market[shop]) {
    }
    if ((market[shop] || []).length > 0) {
      return <Icon src={icon} width={width} style={{ marginLeft: '-10px' }} />;
    }
    return <div />;
  };
  return (
    <>
      {getIcon('ozon1', b_white)}
      {getIcon('ozon2', b_max)}
      {getIcon('ozon3', ururu)}
      {getIcon('ozon4', ozon4)}
      {getIcon('ozon5', ozon5)}
      {getIcon('ozon6', ozon6)}
      {getIcon('ozon7', ozon7)}
      {getIcon('yandex1', yandex1)}
      {getIcon('yandex2', yandex2)}
      {getIcon('yandex3', yandex3)}
      {getIcon('yandex4', yandex4)}
      {getIcon('yandex5', yandex5)}
      {getIcon('yandex6', yandex6)}
      {getIcon('yandex7', yandex7)}
      {getIcon('yandex8', yandex8)}
      {getIcon('wb1', wb1)}
      {getIcon('wb2', wb2)}
      {getIcon('wb3', wb3)}
      {getIcon('wb4', wb4)}
      {getIcon('wb5', wb5)}
      {getIcon('wb6', wb6)}
      {getIcon('wb7', wb7)}
      {getIcon('megamarket1', sber)}
      {getIcon('megamarket2', sber2)}
    </>
  );
};

export default MarketsPairs;
